

const permissions = {
    admin: {
        'course-menu-list': {
            'read:any': ['*']
        },
        'logout': {
            'read:any': ['*']
        }
    },

    dev: {
        'users-list': {
            'read:any': ['search', 'active', 'accessed', 'new'],
        },
        'user-search': {
            'read:any': ['results'],
        },
        'user': {
            'read:any': ['*']
        },
        'review': {
            'read:any': ['*']
        },
        // 'billing-menu': {
        //     'read:any': ['*']
        // },
        // payment-plans-menu retired 2026-08-21 — plans management moved to v2
        // (the 'collections' grant below stays: it is the Levy firm's whole view)
        // reseller-quotes (Quotes / New Quote) + resellers retired 2026-08-31 — quoting moved to v2
        // (removed from admin + reseller roles too; external resellers now quote in v2)
        'collections': {
            'read:any': ['*']
        },
        'settings-list': {
            'read:any': ['*']
        },
        'information': {
            'read:any': ['*']
        },
        'conferences': {
            'read:any': ['*']
        },
        'conferences-legacy': {
            'read:any': ['*']
        },
        'course-menu-list': {
            'read:any': ['*']
        },
        'front-end-dashboard': {
            'read:any': ['*']
        },
        'rmc-dashboard': {
            'read:any': ['*']
        },
        'content-providers': {
            'read:any': ['*']
        },
        'approval': {
            'read:any': ['*']
        },
        'tpo': {
            'read:any': ['*']
        },
        'user-settings': {
            'read:any': ['*']
        },
        'org-settings': {
            'read:any': ['*']
        },
        'wiaa-certification-lookup': {
            'read:any': ['*']
        },
    },


    'admin-production': {
        'users-list': {
            'read:any': ['search', 'active', 'accessed', 'new']
        },
        'user-search': {
            'read:any': ['results']
        },
        'user': {
            'read:any': ['*']
        },
        'logout': {
            'read:any': ['*']
        }
    },


    accountant: {
        'user': {
            'read:any': ['*']
        },
        'logout': {
            'read:any': ['*']
        }
    },

    reseller: {
        'reseller-client-database': {
            'read:any': ['*']
        },
        'reseller-enroll-report': {
            'read:any': ['*']
        },
        'reseller-pending-plans': {
            'read:any': ['*']
        },
        'logout': {
            'read:any': ['*']
        }
    },
    wiaa: {
        'review': {
            'read:any': ['*']
        },
        'conferences': {
            'read:any': ['*']
        },
        'course-menu-list': {
            'read:any': ['*']
        },
        'rmc-dashboard': {
            'read:any': ['*']
        },
        'content-providers': {
            'read:any': ['*']
        },
        'approval': {
            'read:any': ['*']
        },
        'org-settings': {
            'read:any': ['*']
        },
        'user-settings': {
            'read:any': ['*']
        },
        'logout': {
            'read:any': ['*']
        },
        'wiaa-certification-lookup': {
            'read:any': ['*']
        },
    },
    'wiaa-review': {
        'review': {
            'read:any': ['*']
        },
        'user-settings': {
            'read:any': ['*']
        },
        'logout': {
            'read:any': ['*']
        }
    },
    wiaaRMC: {
        'conferences': {
            'read:any': ['*']
        },
        'review': {
            'read:any': ['*']
        },
        'rmc-dashboard': {
            'read:any': ['*']
        },
        'user-settings': {
            'read:any': ['*']
        },
        'logout': {
            'read:any': ['*']
        }
    },
    wsca: {
        'conferences': {
            'read:any': ['*']
        },
        'course-menu-list': {
            'read:any': ['*']
        },
        'user-settings': {
            'read:any': ['*']
        },
        'logout': {
            'read:any': ['*']
        },
        'content-providers': {
            'read:any': ['*']
        },
        'approval': {
            'read:any': ['*']
        },
        'org-settings': {
            'read:any': ['*']
        },
        'review': {
            'read:any': ['*']
        },
    },
    wssaaa: {
        'conferences': {
            'read:any': ['*']
        },
        'course-menu-list': {
            'read:any': ['*']
        },
        'user-settings': {
            'read:any': ['*']
        },
        'logout': {
            'read:any': ['*']
        },
        'content-providers': {
            'read:any': ['*']
        },
        'approval': {
            'read:any': ['*']
        },
        'org-settings': {
            'read:any': ['*']
        },
        'review': {
            'read:any': ['*']
        },
    },
    collections: {
        'collections': {
            'read:any': ['*']
        },
        'user-settings': {
            'read:any': ['*']
        },
        'logout': {
            'read:any': ['*']
        }
    },
    'finalforms': {
        'wiaa-certification-lookup': {
            'read:any': ['*']
        },
        'user-settings': {
            'read:any': ['*']
        },
        'logout': {
            'read:any': ['*']
        }
    }
};

import _ from 'lodash';
import AccessControl from 'accesscontrol';
export const ac = new AccessControl(permissions);

export function allowed(role, permission, attributes) {
    if (attributes) {
        if (!Array.isArray(attributes)) attributes = [attributes];
        let grantedAttrs = ac.can(role).readAny(permission).attributes;
        return (_.difference(attributes, grantedAttrs).length === 0);
    } else {
        return ac.can(role).readAny(permission).granted;
    }
}
